import { SelectedVehicleService } from 'src/app/services/selectedVehicle.service';
import { AttachmentService } from './../../../services/attachment.service';
import { LoadingService } from './../../../services/loading.service';
import { VehicleReservationState } from './../../../models/enums/BookingEnums';
import { AuthService } from './../../../services/auth.service';
import { element } from 'protractor';
import { BookingService } from './../../../services/booking.service';
import { Router } from '@angular/router';
import { LoginModalBodyComponent } from './../login-modal-body/login-modal-body.component';
import { ReviewsModalBodyComponent } from './../../search-location/reviews-modal-body/reviews-modal-body.component';
import { SearchService } from 'src/app/services/search.service';
import { ChangeDetectorRef, Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { ViewEncapsulation, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CountdownComponent } from 'ngx-countdown';
import { MyBookingModel } from 'src/app/models/Booking/MyBookingModel';
import { Vehicle } from 'src/app/models/Vehicle';
import { Customer } from 'src/app/models/Customer';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { RentalVehicleNotAvailableComponent } from '../rental-vehicle-not-available/rental-vehicle-not-available.component';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { IconService } from './../../../services/icon.service';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'my-favourits',
  templateUrl: './my-favourits.component.html',
  styleUrls: ['./my-favourits.component.scss']
})
export class MyFavouritsComponent implements OnInit,OnDestroy {

  @Input() selected: boolean;
  @Output() selectedChange = new EventEmitter<boolean>();
  subscriptions=[];
  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;
  showCountDown = false;
  thierIsBokking = true;

  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  vehicle: Vehicle;
  currency;
  duration;
  vehicles: Vehicle[];

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  customer: Customer;
  gracePeriod: number;
  constructor(
    private attachmentService: AttachmentService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
    private _formBuilder: FormBuilder,
    private searchService: SearchService,
    private authService: AuthService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private _dateFormatPipe: DateFormatPipe,
    private dialog: MatDialog,
    private bookingService: BookingService,
    private router: Router,
    private imageService: ImageService,
    private iconService: IconService,
    private selectedVehicleService: SelectedVehicleService) {

    //this.myBookings=bookingService.getMyBookings();

    //this.vehicle = service.getVehicle();
    this.currency = searchService.getCurrency();

    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );


  }


  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }

  /* public toggleFavorite(vehicle:Vehicle) {
    vehicle.isFavorite=true;
    this.selected = true;
    this.selectedChange.emit(this.selected);
  } */

  ngOnInit() {
    // this.bookingService.vehicle.subscribe(res =>{
    //    this.vehicle = res;});

    let scopeMinTime;
    this.subscriptions.push(this.searchService.reservationSettingModel.subscribe(res => {
      let gracePeriod = 0;
      if (res != null) {
        gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
      }
      this.gracePeriod = gracePeriod;
    }));
    this.cd.markForCheck();
    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => {
      this.customer = res;
      if (res != null) {

        setTimeout(() => {
          this.loadingService.updateLoadingState(true);
        });

        this.getCustomerFavouriteReservations(res.customerID);

      }
    }));

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })

  }
  getCustomerFavouriteReservations(customerID) {
    this.subscriptions.push(this.searchService.getCustomerFavouriteReservations(customerID).subscribe(res => {




      let _myFavourites: Vehicle[] = [];
      res.forEach(element => {
        var searchType = this.getSearchType(element);
        let vehicle = this.searchService.customerFavouriteReservationsToVehicle(element, searchType);
        if (vehicle != null) {
          if (vehicle.campaignsReservationCaseModel != null) {
            vehicle.campaignID = vehicle.campaignsReservationCaseModel.campaignID;
          }
          if (vehicle.membershipModel != null && vehicle.membershipModel.membershipName != null) {
            vehicle.membershipID = vehicle.membershipModel.membershipID;
          }
        }


        _myFavourites.push(vehicle);

        //let walkArround: any = element;
        //_myBooking.push(new Vehicle(walkArround, searchType));

      });
      this.loadingService.updateLoadingState(false);
      this.cd.markForCheck();
      this.vehicles = _myFavourites;




    }));
  }






  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  getSearchType(res) {

    if (res.vehicleID != null) {

      return VehicleSearchTypeEnum.vehicleSearch;
    }
    else if (res.makeID != null && res.modelID != null && res.year != null) {

      return VehicleSearchTypeEnum.MakeModelYearSearch;
    }
    else {

      return VehicleSearchTypeEnum.classSearch;
    }
  }
  public toggleFavorite(vehicle: Vehicle) {
    let _isFavoriteState = vehicle.isFavorite;


    if (!_isFavoriteState) {

    }
    else {
      if (vehicle.customerFavouriteReservationID != null) {
        this.searchService.deleteCustomerFavouriteReservation(vehicle.customerFavouriteReservationID, this.customer.defaultName).subscribe(res => {

          vehicle.isFavorite = !vehicle.isFavorite;
          vehicle.customerFavouriteReservationID = null;

          const index = this.vehicles.indexOf(vehicle, 0);
          if (index > -1) {
            this.vehicles.splice(index, 1);
          }
          this.getCustomerFavouriteReservations(this.customer.customerID);

        });
      }
    }
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
  }

  /*CountDown */
  status = 'start';
  @ViewChild('countdown') counter: CountdownComponent;
  finishTest() {
    this.status = 'finished';
    this.counter.restart();
  }
  resetTimer() {
    this.counter.restart();
  }


  viewBooking(myBookings: MyBookingModel) {
    this.router.navigate(['/view-booking', { CaseID: myBookings.caseID }]);
  }

  onBookNowClicked(vehicle) {


    //this.bookingService.updateVehicle(vehicle);

    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    let minTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html



    let req: VehicleReservationSearchParm = {

      StartDateString: this._dateFormatPipe.transform(today),
      StartTimeString: minTime,
      EndDateString: this._dateFormatPipe.transform(tomorrow),
      EndTimeString: minTime,
      ToAgencyID: vehicle.dropOffLocationID,
      FromAgencyID: vehicle.pickupLocationID,
      AgencyID: vehicle.pickupLocationID,
      ClassID: vehicle.classID,
      VehicleID: vehicle.vehicleID,
      MakeID: vehicle.makeID,
      ModelID: vehicle.modelID,
      Year: vehicle.year,
      DropOffLocationTypeID: vehicle.dropOffLocationTypeID,
      CustomerID: this.customer.customerID
    };


    this.bookingService.checkReservationCaseAvailability(req).subscribe(res => {



      if (res != null) {
        let searchModel = {
          StartDateString: this._dateFormatPipe.transform(today),
          StartTimeString: minTime,
          EndDateString: this._dateFormatPipe.transform(tomorrow),
          EndTimeString: minTime,
          AgencyID: vehicle.pickupLocationID,
          FromAgencyName: vehicle.fromAgencyName,
          DropOffLocationID: vehicle.dropOffLocationID,
          DropUpLocationAgencyId: vehicle.dropOffLocationID,
          DropOffLocationTypeID: vehicle.dropOffLocationTypeID,
          StartDate: today,
          EndDate: tomorrow,
          isFromFavorite:true,
        }

        this.selectedVehicleService.updateVehicle(vehicle);
        this.bookingService.cachedVehicle(vehicle);
        this.bookingService.vehicleShared = vehicle;
        this.bookingService.searchModelShared = searchModel;
        this.bookingService.updateSearchModel(searchModel);
        this.searchService.updateSearchModel(searchModel);
        this.bookingService.deleteCachedReservationSaveAndConfirm();
        this.router.navigate(['/booking']);
      }
      else {
        //Show Not Available
        this.RentalVehicleNotAvailable();
      }

    }, err => {
      this.RentalVehicleNotAvailable();
    });



    //this.bookingService.updateSearchModel(this.searchModel);
    //this.bookingService.searchModelShared=this.searchModel;


  }


  RentalVehicleNotAvailable() {

    const dialogConfig = new MatDialogConfig();
    this.dialog.open(RentalVehicleNotAvailableComponent, dialogConfig);
  }


  onVehicleImageClicked(vehicle: Vehicle) {

    vehicle.isImageClicked = true;
    this.imageService.updateVehicleImage(vehicle);
  }




  openReviewDialog(vehicle) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle
    }
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }




}


